export default "__VITE_ASSET__CuDjju2r__"